import React, { Component } from "react";
import { Table } from "semantic-ui-react";
import _ from "lodash";

const vehicleInfoExcludeNodes = [
  "VIN",
  "type",
  "make",
  "style",
  "model",
  "series",
  "vehicleRecordId",
  "iterationKey",
  "sequenceKey",
  "yearMake",
  "stateOfOrigin",
];

class VehicleInfo extends Component {
  state = {
    rows: [],
    activeIndex: -1,
  };

  componentDidMount() {
    this.loadData(this.props);
  }

  loadData = (props) => {
    const rows = [];
    if (props.record !== undefined) {
      const record = _.get(props.record, "vehicleInfo[0]");
      const index = props.detailIndex;
      rows.push(
        <Table.Row key={`veh_inf_row_1_${index}`}>
          <Table.Cell>VIN:</Table.Cell>
          <Table.Cell>{_.get(record, "VIN[0]._", "")}</Table.Cell>
          <Table.Cell>Vehicle Type:</Table.Cell>
          <Table.Cell>{_.get(record, "type[0]._", "")}</Table.Cell>
        </Table.Row>
      );
      rows.push(
        <Table.Row key={`veh_inf_row_2_${index}`}>
          <Table.Cell>Make:</Table.Cell>
          <Table.Cell>{_.get(record, "make[0]._", "")}</Table.Cell>
          <Table.Cell>Body Type:</Table.Cell>
          <Table.Cell>{_.get(record, "style[0]._", "")}</Table.Cell>
        </Table.Row>
      );
      rows.push(
        <Table.Row key={`veh_inf_row_3_${index}`}>
          <Table.Cell>Model:</Table.Cell>
          <Table.Cell>{_.get(record, "model[0]._", "")}</Table.Cell>
          <Table.Cell>Series:</Table.Cell>
          <Table.Cell>{_.get(record, "series[0]._", "")}</Table.Cell>
        </Table.Row>
      );
      rows.push(
        <Table.Row key={`veh_inf_row_4_${index}`}>
          <Table.Cell>Year:</Table.Cell>
          <Table.Cell>{_.get(record, "yearMake[0]._", "")}</Table.Cell>
          <Table.Cell>State of Origin:</Table.Cell>
          <Table.Cell>{_.get(record, "stateOfOrigin[0]._", "")}</Table.Cell>
        </Table.Row>
      );
      this.addOtherRows(record, rows, props.detailIndex);
    }
    this.setState({ rows });
  };

  addOtherRows = (record, rows, index) => {
    _.forEach(Object.keys(record), (key, keyIndex) => {
      if (vehicleInfoExcludeNodes.indexOf(key) === -1) {
        const value = _.get(record, `${key}[0]._`, "");
        if (value !== "") {
          rows.push(
            <Table.Row key={`veh_inf_other_row_${index}_${keyIndex}`}>
              <Table.Cell colSpan={2}>&#160;</Table.Cell>
              <Table.Cell>{_.get(record, `${key}[0].$.display`)}</Table.Cell>
              <Table.Cell>{value}</Table.Cell>
            </Table.Row>
          );
        }
      }
    });
  };

  handleClick = () => {
    if (this.state.activeIndex === 0) {
      this.setState({ activeIndex: -1 });
    } else {
      this.setState({ activeIndex: 0 });
    }
  };

  render() {
    return (
      <Table>
        <Table.Body>
          <Table.Row>
            <Table.HeaderCell
              key={`veh_det_title`}
              colSpan={4}
              className="report-sub-section-header"
            >
              <center>Vehicle Details</center>
            </Table.HeaderCell>
          </Table.Row>
          {this.state.rows}
        </Table.Body>
      </Table>
    );
  }
}

export default VehicleInfo;



// WEBPACK FOOTER //
// ./src/components/reports/Platinum/VehicleInfo.js